module.exports = __webpack_public_path__ + "static/media/banner.6053ce57.jpg";